"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.design = void 0;
var type_guard_1 = require("@webnuts/type-guard");
var ramda_1 = require("ramda");
var factory_utils_1 = require("./internal/factory-utils");
var design = function (factories, global, config, breakpoints) {
    var e_1, _a, e_2, _b;
    if (breakpoints === void 0) { breakpoints = factory_utils_1.DEFAULT_BREAKPOINTS; }
    type_guard_1.assert(type_guard_1.record(type_guard_1.string(), type_guard_1.func()), factories, function (invalidation) {
        var invalidStr = JSON.stringify(invalidation, undefined, 2);
        return new Error("\"design\" expects first argument to be an object of factory functions: " + invalidStr + "\"");
    });
    var _loop_1 = function (alias, componentFactory) {
        type_guard_1.assert(type_guard_1.startsWith(componentFactory.name), alias, function (invalidation) {
            var invalidStr = JSON.stringify(invalidation, undefined, 2);
            return new Error("\"design\" expects aliases for component-factory \"" + componentFactory.name + "\" must start with \"" + componentFactory.name + "\": " + invalidStr);
        });
    };
    try {
        for (var _c = __values(Object.entries(factories)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var _e = __read(_d.value, 2), alias = _e[0], componentFactory = _e[1];
            _loop_1(alias, componentFactory);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    type_guard_1.assert(type_guard_1.record(type_guard_1.string(), type_guard_1.any()), global, function (invalidation) {
        var invalidStr = JSON.stringify(invalidation, undefined, 2);
        return new Error("\"design\" expects second argument to be an object: " + invalidStr);
    });
    var services = {
        global: ramda_1.path(ramda_1.__, global)
    };
    var resolvedConfig = typeof config === 'function' ? config(services) : config;
    type_guard_1.assert(type_guard_1.record(type_guard_1.string(), type_guard_1.any()), resolvedConfig, function (invalidation) {
        var invalidStr = JSON.stringify(invalidation, undefined, 2);
        return new Error("\"design\" expects third argument to be an object or a function returning an object: " + invalidStr);
    });
    var _loop_2 = function (alias, aliasConfig) {
        var e_3, _a;
        type_guard_1.assert(type_guard_1.record(type_guard_1.string(), type_guard_1.any()), aliasConfig, function (invalidation) {
            var invalidStr = JSON.stringify(invalidation, undefined, 2);
            return new Error("\"design\" expects config-value for alias \"" + alias + "\" to be an object: " + invalidStr);
        });
        var _loop_3 = function (variantName, variantConfig) {
            type_guard_1.assert(type_guard_1.record(type_guard_1.string(), type_guard_1.any()), variantConfig, function (invalidation) {
                var invalidStr = JSON.stringify(invalidation, undefined, 2);
                return new Error("\"design\" expects config-value for variant \"" + alias + "." + variantName + "\" to be an object: " + invalidStr);
            });
        };
        try {
            for (var _b = (e_3 = void 0, __values(Object.entries(aliasConfig))), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), variantName = _d[0], variantConfig = _d[1];
                _loop_3(variantName, variantConfig);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    try {
        for (var _f = __values(Object.entries(resolvedConfig)), _g = _f.next(); !_g.done; _g = _f.next()) {
            var _h = __read(_g.value, 2), alias = _h[0], aliasConfig = _h[1];
            _loop_2(alias, aliasConfig);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
        }
        finally { if (e_2) throw e_2.error; }
    }
    var utils = factory_utils_1.createUtils(breakpoints);
    var components = Object.entries(resolvedConfig).reduce(function (acc, _a) {
        var _b = __read(_a, 2), alias = _b[0], variants = _b[1];
        var componentFactory = factories[alias];
        var defaultSettings = resolvedConfig[alias].default;
        return __assign(__assign({}, acc), Object.entries(variants).reduce(function (accVariants, _a) {
            var _b;
            var _c = __read(_a, 2), variantName = _c[0], variantSettings = _c[1];
            var displayName = variantName === 'default' ? alias : variantName;
            var settings = ramda_1.mergeDeepRight(defaultSettings, variantSettings);
            return __assign(__assign({}, accVariants), (_b = {}, _b[displayName] = componentFactory(displayName, settings, utils), _b));
        }, {}));
    }, {});
    return __assign({ utils: utils,
        breakpoints: breakpoints, config: resolvedConfig }, components);
};
exports.design = design;
